export default __webpack_public_path__ + "static/media/ADIZ_01_mos_SAMF.600f3c30.wav";